import type { ChatCompletion } from 'openai/resources/chat/completions';

/**
 * Log Formatting Utility for Smart chat. 

 * Enabled by default when NODE_ENV is not production 
 * or when SMART_CHAT_LOG_STATS=true
 *
 */
export const BEDROCK_OPENAI_CHAT_USAGE_MARKER = 'BEDROCK_OPENAI_CHAT_USAGE';

export function logAiCompletionStats(flow: string, completion: ChatCompletion): void {
  if (!isOpenAiChatUsageLoggingEnabled()) {
    return;
  }

  const usage = completion.usage;
  const cachedTokens = usage?.prompt_tokens_details?.cached_tokens ?? 0;

  const payload = {
    marker: BEDROCK_OPENAI_CHAT_USAGE_MARKER,
    flow,
    model: completion.model,
    prompt_tokens: usage?.prompt_tokens ?? null,
    completion_tokens: usage?.completion_tokens ?? null,
    cached_prompt_tokens: cachedTokens,
    prompt_cache_hit: cachedTokens > 0,
  };

  console.warn(JSON.stringify(payload));
}

function isOpenAiChatUsageLoggingEnabled(): boolean {
  if (process.env.SMART_CHAT_LOG_STATS === 'true') {
    return true;
  }
  if (process.env.SMART_CHAT_LOG_STATS === 'false') {
    return false;
  }
  if (process.env.NODE_ENV === 'test') {
    return false;
  }
  return process.env.NODE_ENV !== 'production';
}
